import { __ } from '@/utils/utils'
import type { InsightProProps } from '@/components/AcuityComponents/InsightProSection/InsightProSection.types'

export const defaultProps: InsightProProps = {
  title: '',
  description: '',
  image: '',
  content: [],
  align: 'left',
  backgroundColor: 'white',
  leftButton: {
    title: 'Open an Account',
    routeName: 'live-registration'
  },
  rightButton: {
    title: 'Try a demo',
    routeName: 'demo-registration'
  }
}
